import { useCallback } from 'react';
import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

export function useMeetingModal(aiId: string | null) {
  const { isPermitted } = useActionItem(aiId);
  const canMeet = isPermitted(Operation.addToMeeting);
  const showMeetingsDialog = useCallback(() => {
    window.initMeetingsAddDialog({
      type: 'team',
      target: {
        targetType: 'action-item',
        apiProperty: 'act_id',
        id: aiId,
      },
    });
  }, [aiId]);

  return [canMeet, showMeetingsDialog] as const;
}
